var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", [
    _c("nav", { staticClass: "navbar navbar-light mc-topbar fixed-top" }, [
      _c("div", { staticClass: "container navbar-container" }, [
        _vm._m(0),
        _c("div", { staticClass: "ml-auto d-flex" }, [
          _c("div", { staticClass: "mainmenu-btn mr-2 d-none d-sm-block" }, [
            _c(
              "a",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      this.$route.name !== "Disclaimer" &&
                      this.$route.name !== "LgSearch" &&
                      (this.$route.name !== "changePassword" &&
                        this.$store.getters.authStatus !== "successFirst"),
                    expression:
                      "this.$route.name!=='Disclaimer' && this.$route.name!=='LgSearch' && (this.$route.name!=='changePassword' && this.$store.getters.authStatus!=='successFirst')"
                  }
                ],
                staticClass: "btn btn-secondary-custom white-version shadowed",
                staticStyle: { cursor: "pointer" },
                on: {
                  click: function($event) {
                    return _vm.mainpage()
                  }
                }
              },
              [
                _c("i", { staticClass: "feather-icon icon-grid" }),
                _vm._v("เมนูหลัก\n          ")
              ]
            )
          ]),
          _c(
            "div",
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-noborder dropdown-toggle",
                  attrs: {
                    type: "button",
                    id: "profile-btn",
                    "data-toggle": "dropdown",
                    "aria-haspopup": "true",
                    "aria-expanded": "false"
                  }
                },
                [
                  _c("i", { staticClass: "feather-icon icon-user" }),
                  _c("span", [_vm._v(_vm._s(_vm.name))])
                ]
              ),
              _c(
                "b-dropdown",
                [
                  _c(
                    "b-dropdown-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            this.$route.name !== "Disclaimer" &&
                            this.$route.name !== "LgSearch",
                          expression:
                            "this.$route.name!=='Disclaimer' && this.$route.name!=='LgSearch'"
                        }
                      ],
                      attrs: { to: "taskList" }
                    },
                    [
                      _c("i", { staticClass: "feather-icon icon-list" }),
                      _vm._v("ยืนยันการขอใช้วงเงิน\n            ")
                    ]
                  ),
                  _c(
                    "b-dropdown-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            this.$route.name !== "Disclaimer" &&
                            this.$route.name !== "LgSearch",
                          expression:
                            "this.$route.name!=='Disclaimer' && this.$route.name!=='LgSearch'"
                        }
                      ],
                      attrs: { to: "taskHistoryList" }
                    },
                    [
                      _c("i", { staticClass: "feather-icon icon-list" }),
                      _vm._v("ประวัติการขอใช้วงเงิน\n            ")
                    ]
                  ),
                  _c(
                    "b-dropdown-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            this.$route.name !== "Disclaimer" &&
                            this.$route.name !== "LgSearch",
                          expression:
                            "this.$route.name!=='Disclaimer' && this.$route.name!=='LgSearch'"
                        }
                      ],
                      attrs: { to: "apphistory" }
                    },
                    [
                      _c("i", { staticClass: "feather-icon icon-list" }),
                      _vm._v("ประวัติการทำรายการ\n            ")
                    ]
                  ),
                  _c(
                    "b-dropdown-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: this.$route.name !== "Disclaimer",
                          expression: "this.$route.name!=='Disclaimer'"
                        }
                      ],
                      attrs: { to: "changePassword" }
                    },
                    [
                      _c("i", { staticClass: "feather-icon icon-user-check" }),
                      _vm._v("เปลี่ยนรหัสผ่าน\n            ")
                    ]
                  ),
                  _c(
                    "b-dropdown-item",
                    {
                      on: {
                        click: function($event) {
                          return _vm.logout()
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "feather-icon icon-log-out" }),
                      _vm._v("ออกจากระบบ\n            ")
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._m(1)
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "navbar-brand", attrs: { href: "#" } }, [
      _c("div", { staticClass: "logo-brand" }, [
        _c("div", { staticClass: "ktb-logo" }, [
          _c("img", { attrs: { src: require("@/resources/img/ktb-logo.png") } })
        ]),
        _c("div", { staticClass: "vertical-line" }),
        _c("div", { staticClass: "mc-logo" }, [
          _c("img", { attrs: { src: require("@/resources/img/h_elg.jpg") } })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mobile-menu-toggle" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-noborder mobile-menu-btn",
          attrs: { type: "button", id: "mobile-menu-toggle" }
        },
        [_c("i", { staticClass: "feather-icon icon-menu" })]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }